import { render, staticRenderFns } from "./BrandActionDelete.vue?vue&type=template&id=8e3508aa&"
import script from "./BrandActionDelete.vue?vue&type=script&lang=ts&"
export * from "./BrandActionDelete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports